import { cn } from "@/lib/utils/cn";

/** JebaXP symbol for compact navigation and utility surfaces. */
export function BrandMark({ size = 36, className }: { size?: number; className?: string }) {
  return (
    <img
      src="/brand/jebaxp-mark.png"
      alt="JebaXP"
      width={size}
      height={size}
      className={cn("shrink-0 object-contain", className)}
    />
  );
}

/** Wordmark with the supplied high-contrast variants for the selected theme. */
export function BrandWordmark({ className }: { className?: string }) {
  return (
    <>
      <img src="/brand/jebaxp-wordmark-dark.png" alt="JebaXP" className={cn("h-8 w-auto dark:hidden", className)} />
      <img src="/brand/jebaxp-wordmark-light.png" alt="JebaXP" className={cn("hidden h-8 w-auto dark:block", className)} />
    </>
  );
}
